module.exports = __webpack_public_path__ + "static/media/past-encounter-off.c76de94d.svg";